'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // The posible statuses:
//     CONFIRMED,                         1) user is on first step (Fill User data)
//     USER_DATA_FILLED,                  2) user is on second step (Sign NDA)
//     SIGNED,                            3) user is on second step (Sign NDA (Pending))
//     KYC_PASSED,                        4) user is on second step (Sign NDA (Pending))
//     ACCOUNT_CREATED,                   5) user is on third step (KYC documents)
//     KYC_DOCUMENT_ADDED,                6) user is on forth step (Add payment method (Pending))
//     KYC_DOCUMENT_VALIDATED,            7) user is on forth step (Add payment method)
//     PAYMENT_METHOD_ADDED,              8) user is on fifth step (Fill wallet (Pending) )
//     WAITING_FOR_WALLET_REPLENISHMENT,  9) user is on fifth step (Fill wallet)
//     WALLET_FILLED                      10) user is on final step ( wallet filled )
//     SUBSCRIPTION_BOUGHT                11) user is on CO added
//     COMPLIANCE_OFFICER_ADDED           12) user is on (Congratulation) and see OK button

var userStatus = {
  NA: 'NA',
  APPLIED: 'APPLIED',
  // for Sp Admin
  REGISTERED: 'REGISTERED',
  // for applied Sp Admin
  INVITED: 'INVITED',
  CONFIRMED: 'CONFIRMED',
  // user set password
  USER_DATA_FILLED: 'USER_DATA_FILLED',
  CV_ADDED: 'CV_ADDED',
  // for Advisor
  SIGNED: 'SIGNED',
  KYC_PASSED: 'KYC_PASSED',
  ACCOUNT_CREATED: 'ACCOUNT_CREATED',
  KYC_DOCUMENT_ADDED: 'KYC_DOCUMENT_ADDED',
  KYC_DOCUMENT_VALIDATED: 'KYC_DOCUMENT_VALIDATED',
  PAYMENT_METHOD_ADDED: 'PAYMENT_METHOD_ADDED',
  WAITING_FOR_WALLET_REPLENISHMENT: 'WAITING_FOR_WALLET_REPLENISHMENT',
  WALLET_FILLED: 'WALLET_FILLED',
  SUBSCRIPTION_BOUGHT: 'SUBSCRIPTION_BOUGHT',
  // for Sp Admin
  COMPLIANCE_OFFICER_ADDED: 'COMPLIANCE_OFFICER_ADDED' // for Sp Admin

};
exports.default = userStatus;